<template>
    <div class="sidebar">

        <div class="navbar-left">
            <img class="logo" src="https://mktv-in-cdn.mockuai.com/16214055577635305.png" alt="">
        </div>
        <SidebarForm/>
        <nav class="sidebar-nav">
            <div slot="header"></div>
            <ul class="nav">
                <template v-for="(item, index) in navItems">
                    <template v-if="item.title">
                        <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
                    </template>
                    <template v-else-if="item.divider">
                        <li class="divider"></li>
                    </template>
                    <template v-else>
                        <template v-if="item.children">
                            <!-- First level dropdown -->
                            <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icon">
                                <template v-for="(childL1, index) in item.children">
                                    <template v-if="childL1.children">
                                        <!-- Second level dropdown -->
                                        <SidebarNavDropdown :name="childL1.name" :url="childL1.url"
                                                            :icon="childL1.icon">
                                            <li class="nav-item" v-for="(childL2, index) in childL1.children">
                                                <SidebarNavLink :name="childL2.name" :url="childL2.url"
                                                                :icon="childL2.icon" :badge="childL2.badge"
                                                                :font_icon="childL2.font_icon"
                                                                :variant="item.variant"/>
                                            </li>
                                        </SidebarNavDropdown>
                                    </template>
                                    <template v-else>
                                        <SidebarNavItem :classes="item.class">
                                            <SidebarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :font_icon="childL1.font_icon"
                                                            :badge="childL1.badge" :variant="item.variant"/>
                                        </SidebarNavItem>
                                    </template>
                                </template>
                            </SidebarNavDropdown>
                        </template>
                        <template v-else>
                            <SidebarNavItem :classes="item.class" :itemName="item.name">
                                <SidebarNavLink :name="item.name" :url="item.url" :icon="item.icon" :font_icon="item.font_icon"
                                                :badge="item.badge" :variant="item.variant"/>
                            </SidebarNavItem>
                        </template>
                    </template>
                </template>
            </ul>
            <slot></slot>
        </nav>
        <SidebarFooter/>
        <!-- <div class="sidebar-footer" @click="triggerClick">
            <i class="el-icon-d-arrow-left" style="margin: 0 20px 0 4px"></i>
            收缩侧边栏
        </div> -->
        <div class="nav-tooltip collapsed" @click="sidebarToggle">
            <div class="nav-tooltip-rel">
                <div>
                    <i class="icon el-icon-d-arrow-right"></i>
                    <i class="icon el-icon-d-arrow-left"></i>
                    <span class="nav-name">收缩侧边栏</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import SidebarFooter from './SidebarFooter';
  import SidebarForm from './SidebarForm';
  import SidebarHeader from './SidebarHeader';
  import SidebarMinimizer from './SidebarMinimizer';
  import SidebarNavDropdown from './SidebarNavDropdown';
  import SidebarNavLink from './SidebarNavLink';
  import SidebarNavTitle from './SidebarNavTitle';
  import SidebarNavItem from './SidebarNavItem';

  export default {
    name: 'sidebar',
    props: {
      navItems: {
        type: Array,
        required: true,
        default: () => [],
      },
      copyright: {
        type: String,
        default: ''
      },
      logoUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        host: ''
      }
    },
    created() {
      this.host = location.host;
    },
    components: {
      SidebarFooter,
      SidebarForm,
      SidebarHeader,
      SidebarMinimizer,
      SidebarNavDropdown,
      SidebarNavLink,
      SidebarNavTitle,
      SidebarNavItem,
    },
    methods: {
      handleClick(e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
      },
      mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
      },
      sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
      }
    },
  };
</script>

<style lang="scss">
    .sidebar {
        .navbar-left {
            display: flex;
            align-items: center;
            //justify-content: center;
            background: #FFF;
            width: 164px;
            height: 64px;
            box-shadow: 0 2px 6px 0 rgba(136, 156, 176, 0.2);
            border-bottom: 1px solid #c2cfd6;
            text-align: center;
            padding-left: 15px;
            .logo {
              max-height: 45px;
            }
        }

        .el-icon-d-arrow-right{
            display: none;
        }

        .nav-tooltip, .nav-tooltip-rel {
            display: inline-block;
        }

        .collapsed {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 38px;
            line-height: 38px;
            background: #2F3E75;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
            .icon {
                position: absolute;
                left: 40px;
                top: 0;
                height: 38px;
                line-height: 38px;
            }
            .nav-name {
                position: absolute;
                left: 57px;
                top: 0;
                height: 38px;
                line-height: 38px;
            }
            &:hover{
                color: #FFFFFF;
            }
        }
    }

    .sidebar-hidden{
        .el-icon-d-arrow-left{
            display: none;
        }
        .el-icon-d-arrow-right{
            display: block;
        }
    }



    .logo2 {
        margin: 16px 0 0 18px;
        width: 130px;
        background: url(https://img.mockuai.com/tms/2018/3/28/upload_c63eca99f4a89c6940059a4f5eecaa8d.png) no-repeat;
        background-size: 100%;
    }

    .logo_url {
        display: inline-block;
        width: 150px;
        height: 55px;
        padding: 0.5rem 1rem;
        margin-right: 0;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 75%;
    }

    .sidebar-nav {
        background-color: #182248;
    }

    .nav-link {
        cursor: pointer;
        height: 54px !important;
        line-height: 54px !important;
        padding: 0 !important;
    }

    .sidebar {
        position: absolute;
        width: 164px;
        left: 0;
        background: #292c33;
        padding-bottom: 38px;
        overflow: hidden;
    }

    .sidebar .nav-link i {
        margin: 0 8px 0 24px !important;
        vertical-align: middle;
        font-size: 14px;
        color:#d9e4eb;
    }

    .sidebar .nav-link .nav-name {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        font-weight: 500;
    }

    .nav-link:hover{
        background: #30407D !important;
    }
    .nav-link.active {
        background: #3E89FF !important;
    }

    .nav-link.active {
        position: relative;
        // &:before {
        //     content: '';
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //     width: 3px;
        //     height: 54px;
        //     background: #fff;
        // }
        i {
            color: #fff !important;
        }
    }
</style>
